module.exports = __webpack_public_path__ + "img/myloading.3bc95ceb.png";